
$(document).ready(function(){

  // ---------------------------------------------------------------------------
  // Collection & search UX (TID-100)
  // Keeps facet accordions open after AJAX filter reloads, left-aligns sparse
  // product grids (<=2 results), and moves sold-out cards to the end of the grid.
  // Observers are split so hover-image DOM updates inside cards do not re-sort.
  // ---------------------------------------------------------------------------

  /** Stable sessionStorage key for a facet block (id, or title text as fallback). */
  function facetStorageKey(facet) {
    var id = facet.id;
    if (id) return id;
    var title = facet.querySelector('.t4s-facet-title');
    return title ? title.textContent.trim() : '';
  }

  /**
   * Re-open facet accordions after sidebar AJAX refresh.
   * Opens when the facet has an active filter (.is--selected) or when the
   * shopper left it open in this session (sessionStorage key fts-facet:*).
   */
  function restoreFacetAccordions() {
    document.querySelectorAll('.c_collection-filter .t4s-facet').forEach(function (facet) {
      var content = facet.querySelector('.t4s-facet-contnt');
      var title = facet.querySelector('.t4s-facet-title');
      if (!content || !title) return;

      var key = facetStorageKey(facet);
      var hasActive = facet.querySelector('.is--selected') !== null;
      var stored = key ? sessionStorage.getItem('fts-facet:' + key) : null;

      if (hasActive || stored === '1') {
        content.style.display = 'block';
        var icon = title.querySelector('.t4s-facet-title-svg');
        if (icon) icon.classList.add('t4s-facet-title-svg-rotate');
      }
    });
  }

  /**
   * Sets data-sparse-results on collection/search AJAX containers when the grid
   * has 1–2 products. CSS uses this to left-align cards instead of spreading them.
   */
  function markSparseProductGrids() {
    document.querySelectorAll('[data-ntajax-container]').forEach(function (container) {
      var grid = container.querySelector('.t4s_box_pr_grid');
      if (!grid) return;
      var count = grid.querySelectorAll('.t4s-product').length;
      container.setAttribute('data-sparse-results', count > 0 && count <= 2 ? 'true' : 'false');
    });
  }

  /**
   * Moves unavailable product cards to the end of collection/search grids.
   * Reads availability from each card's data-product-options JSON (theme default).
   * Skips DOM writes when order is already correct (avoids breaking card hover).
   */
  function sortSoldOutProductsLast() {
    document.querySelectorAll('.t4s-main-collection-page .t4s_box_pr_grid, .t4s-main-collection-search .t4s_box_pr_grid').forEach(function (grid) {
      var products = Array.prototype.slice.call(grid.querySelectorAll(':scope > .t4s-product'));
      if (products.length < 2) return;

      var available = [];
      var soldOut = [];
      products.forEach(function (el) {
        var raw = el.getAttribute('data-product-options');
        if (!raw) {
          available.push(el);
          return;
        }
        try {
          if (JSON.parse(raw).available === false) soldOut.push(el);
          else available.push(el);
        } catch (e) {
          available.push(el);
        }
      });

      if (!soldOut.length) return;

      var ordered = available.concat(soldOut);
      // Only reorder when positions differ — appendChild on every card broke :hover.
      var needsSort = ordered.some(function (el, i) {
        return grid.children[i] !== el;
      });
      if (!needsSort) return;

      ordered.forEach(function (el) {
        grid.appendChild(el);
      });
    });
  }

  /** Runs all collection/search helpers once (page load and after facet events). */
  function refreshCollectionUX() {
    restoreFacetAccordions();
    markSparseProductGrids();
    sortSoldOutProductsLast();
  }

  /** Debounced facet-only restore; does not touch the product grid (see observeProductGrids). */
  function scheduleFacetRestore() {
    restoreFacetAccordions();
    requestAnimationFrame(restoreFacetAccordions);
    setTimeout(restoreFacetAccordions, 100);
    setTimeout(restoreFacetAccordions, 400);
  }

  /** Re-run sparse-grid + sold-out sort after facet AJAX replaces grid children. */
  function scheduleCollectionGridUX() {
    markSparseProductGrids();
    sortSoldOutProductsLast();
    requestAnimationFrame(function () {
      markSparseProductGrids();
      sortSoldOutProductsLast();
    });
    setTimeout(function () {
      markSparseProductGrids();
      sortSoldOutProductsLast();
    }, 100);
  }

  /**
   * Watches filter sidebar markup only. Intentionally excludes [data-ntajax-container]:
   * subtree mutations from hover secondary images/lazysizes must not trigger a re-sort.
   */
  function observeFacetSidebar() {
    document.querySelectorAll('.c_collection-filter, [data-sidebar-content]').forEach(function (root) {
      if (root._ftsFacetObserver) return;
      var timer;
      var observer = new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(scheduleFacetRestore, 50);
      });
      observer.observe(root, { childList: true, subtree: true });
      root._ftsFacetObserver = observer;
    });
  }

  /**
   * Watches direct .t4s-product children on collection/search grids (subtree: false).
   * Fires when facet AJAX adds/removes cards, not on in-card image/hover updates.
   */
  function observeProductGrids() {
    document.querySelectorAll('.t4s-main-collection-page .t4s_box_pr_grid, .t4s-main-collection-search .t4s_box_pr_grid').forEach(function (grid) {
      if (grid._ftsGridObserver) return;
      var timer;
      var observer = new MutationObserver(function (mutations) {
        var gridChanged = mutations.some(function (m) {
          if (m.type !== 'childList' || m.target !== grid) return false;
          return Array.prototype.some.call(m.addedNodes, function (n) {
            return n.nodeType === 1 && n.classList && n.classList.contains('t4s-product');
          }) || Array.prototype.some.call(m.removedNodes, function (n) {
            return n.nodeType === 1 && n.classList && n.classList.contains('t4s-product');
          });
        });
        if (!gridChanged) return;
        clearTimeout(timer);
        timer = setTimeout(scheduleCollectionGridUX, 50);
      });
      observer.observe(grid, { childList: true, subtree: false });
      grid._ftsGridObserver = observer;
    });
  }

  // Initial run + wire observers / theme facet events
  refreshCollectionUX();
  observeFacetSidebar();
  observeProductGrids();
  $(document).on('facets:loaded sidebar:updated', function () {
    scheduleFacetRestore();
    scheduleCollectionGridUX();
    observeProductGrids();
  });
  $(document).on('click', '.c_collection-filter a', scheduleFacetRestore);

    $(`.Navigation-Backtrack`)
    .click(( event ) => {

        const navigation = document
            .querySelector(`.Navigation[ data-layout = mobile ]`)

        const tabs = navigation
            .querySelectorAll(`.Navigation-Tab input:checked`)

        if( tabs.length ){

            Array
            .from(tabs)
            .forEach(( tab ) => tab.checked = false )

            return
        }

        navigation
        .querySelectorAll(`.Navigation-Menu[ data-selected = true ]`)
        .forEach(( menu ) => menu.dataset.selected = String(false) )

        const menus = navigation
            .querySelector('.Navigation-Menus')

        menus.dataset.hideMenus = String(false)
    })

    $(`
        .Navigation[ data-layout = mobile ]
        .Navigation-Menu[ data-has-overlay = true ]
        .Navigation-Item
    `).click(( event ) => {

        event.stopPropagation()
        event.preventDefault()

        const menu = event.target.closest(`.Navigation-Menu`)
        menu.dataset.selected = String(true)

        const menus = menu.closest(`.Navigation-Menus`)
        menus.dataset.hideMenus = String(true)
    })

    document
    .querySelectorAll(`
        .Navigation[ data-layout = mobile ]
        .Navigation-Tab
    `)
    .forEach(( label ) => {
        label.onmouseenter = () => {}
    })


    document
    .querySelectorAll(`
        .Navigation[ data-layout = mobile ]
        label.Navigation-Tab a
    `)
    .forEach(( link ) => {
        link.removeAttribute('href')
    })


     $(".c_header-hamburger").click(function(e){
e.preventDefault();
       e.stopPropagation();
       $(".c_mbl-nav-main").addClass("c_mbl-nav-main-open")
  });

   $(".c_mbl-nav-close, .c_mbl-nav-overly").click(function(){
$(this).closest(".c_mbl-nav-main").removeClass("c_mbl-nav-main-open")
  });

    $(document).on("click",".c_collection-filter .t4s-facet-title",function() {
      // Persist manual open/closed state across facet AJAX reloads (pairs with restoreFacetAccordions).
      var $title = $(this);
      var $content = $title.next(".t4s-facet-contnt");
      $title.find(".t4s-facet-title-svg").toggleClass("t4s-facet-title-svg-rotate");
      $content.slideToggle(200, function() {
        var facet = $title.closest(".t4s-facet")[0];
        if (!facet) return;
        var key = facetStorageKey(facet);
        if (!key) return;
        sessionStorage.setItem('fts-facet:' + key, $content.is(':visible') ? '1' : '0');
      });
  });

      $(document).on("click",".c_fc-price-cart",function() {
      var c_class= $(this)
      var c_id = $(this).attr("data-id");
      var c_qty = parseInt(1);
           console.log("Variant ID: ",c_id,"Variant Qty: ", c_qty);
       variant(c_id,c_qty,c_class);


  });


    function variant(c_id,c_qty,c_class){
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: {
          quantity: c_qty,
          id: c_id
        },
        beforeSend: function() {
          c_class.find(".c_fc-price-cart-loader-main").removeClass("c_fc-price-cart-loader-hide");
          console.log('before enter');
        },
        success:function(rst){
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
                 var cart = c_class.closest('.c_fc-price-b');
     var imgtodrag = c_class.closest('.t4s-product-wrapper').find(".t4s-product-main-img");
           if (imgtodrag.length > 0) {
        var imgclone = imgtodrag.clone().offset({
            top: imgtodrag.offset().top,
            left: imgtodrag.offset().left
        })
        .css({
            'opacity': '0.5',
            'position': 'absolute',
            'height': '150px',
            'width': '150px',
            'z-index': '100'
        })
        .appendTo($('body'))
        .animate({
            'top': cart.offset().top + 10,
            'left': cart.offset().left + 10,
            'width': 75,
            'height': 75
        }, 1000, 'swing');

        setTimeout(function () {
            cart.effect("shake", {
                times: 2
            }, 200);
        }, 1500);

        imgclone.animate({
            'width': 0,
            'height': 0
        }, function () {
            $(this).detach();
        });
    } else {
        console.log("Image element not found.");
    }

          setTimeout(function() {
      $(".t4s-site-nav__cart a").click();
          }, 1000);

          console.log("sccess");
        },
        error:function(msg){
          console.log("Error");
        },complete:function(cart){
          c_class.find(".c_fc-price-cart-loader-main").addClass("c_fc-price-cart-loader-hide");
          console.log("complete");
        }
      });
    }

   var social = $(".t4s-list-socials").detach();
  function socialDetach(social){
  if ($(window).width() < 767) {
  $(".c_social-mbl").html(social)
  console.log("c----", social)
}
  else{
    $(".t4s-socials-block").html(social)
  }
  }

  socialDetach(social)

$(window).resize(function(){
  $(".c_social-mbl").empty()
socialDetach(social)
  });

});
